import { getItemByLabelFactory, getItemByIdFactory } from './_common'
import type { ISelectItem } from '~/types/models'

export enum TeamMemberRoleIds {
  SALES_REP = 1,
  SALES_SUPPORT = 2,
  SOLUTION_ENGINEER = 3,
  SUB_AGENT = 4,
  ENGINEER = 5,
  ACCOUNT_OWNER = 6,
  ORDER_ADMINISTRATOR = 7,
  SERVICEORDER_MANAGER = 8,
  SALES_MANAGER = 9,
  DECISION_MAKER = 10,
  COMMISSION_MANAGER = 11,
  PROJECT_MANAGER = 12,
  // 13 is the server's "Bot" role (cynque-api-server#1600), deliberately not offered here.
  CASES_MANAGER = 14,
  SERVICE_REQUESTS_MANAGER = 15,
  BUSINESS_DEVELOPMENT = 16,
  PARTNER_RELATIONS = 17,
}

const teamMemberRoles = [
  { id: TeamMemberRoleIds.SALES_REP, label: 'Sales Rep' },
  { id: TeamMemberRoleIds.SALES_SUPPORT, label: 'Sales Support' },
  { id: TeamMemberRoleIds.SOLUTION_ENGINEER, label: 'Solution Engineer' },
  { id: TeamMemberRoleIds.SUB_AGENT, label: 'SubAgent' },
  { id: TeamMemberRoleIds.ENGINEER, label: 'Engineer' },
  { id: TeamMemberRoleIds.ACCOUNT_OWNER, label: 'Account Owner' },
  { id: TeamMemberRoleIds.ORDER_ADMINISTRATOR, label: 'Order Administrator' },
  {
    id: TeamMemberRoleIds.SERVICEORDER_MANAGER,
    label: 'Service Order Manager',
  },
  {
    id: TeamMemberRoleIds.SALES_MANAGER,
    label: 'Sales Manager',
  },
  {
    id: TeamMemberRoleIds.DECISION_MAKER,
    label: 'Decision Maker',
  },
  { id: TeamMemberRoleIds.COMMISSION_MANAGER, label: 'Commission Manager' },
  { id: TeamMemberRoleIds.PROJECT_MANAGER, label: 'Project Manager' },
  { id: TeamMemberRoleIds.CASES_MANAGER, label: 'Cases Manager' },
  {
    id: TeamMemberRoleIds.SERVICE_REQUESTS_MANAGER,
    label: 'Service Requests Manager',
  },
  {
    id: TeamMemberRoleIds.BUSINESS_DEVELOPMENT,
    label: 'Business Development',
  },
  { id: TeamMemberRoleIds.PARTNER_RELATIONS, label: 'Partner Relations' },
].sort((a, b) => (a.label > b.label ? 1 : -1))

export function getTeamMemberRoles(): ISelectItem[] {
  return teamMemberRoles
}

export function getTeamMemberRolesWithFilter(
  filter = (tmr: ISelectItem) => true
): ISelectItem[] {
  return teamMemberRoles.filter(filter)
}

export const getTeamMemberRoleByLabel =
  getItemByLabelFactory(getTeamMemberRoles)

export const getTeamMemberRoleById = getItemByIdFactory(getTeamMemberRoles)
